<template>
  <div class="row">
    <div class="col-md-12">
      <dashboard-box :back="true" back-component-name="management.regions.index">
        <template v-slot:title>
          <span>{{ $t("regions.users") }}</span>
        </template>
        <template v-slot:preview>
          <b-row>
            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('regions.name')">
                <b-form-input
                    v-model="form.name"
                    :placeholder="$t('regions.name')"
                    :state="validateState('name')"
                    class="form-control form-control-solid"
                    name="name"
                    type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                    v-if="!validateState('name') && !$v.form.name.required"
                    :state="!(validateState('name') && !$v.form.name.required)">
                  {{ $t('regions.validations.name.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('regions.description')">
                <b-form-input
                    v-model="form.description"
                    :placeholder="$t('regions.description')"
                    class="form-control form-control-solid"
                    :state="validateState('description')"
                    name="description"
                    type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                    v-if="!validateState('description') && !$v.form.description.required"
                    :state="!(validateState('description') && !$v.form.description.required)">
                  {{ $t('regions.validations.description.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <template v-for="(item, index) in form.regions">
              <b-col lg="1" md="1" sm="12" xl="1" class="d-flex align-items-center mt-1">
                <i class="bx bx-trash bx-remove-button" @click="deleteRegion(index)"></i>
              </b-col>

              <b-col lg="4" md="4" sm="12" xl="4">
                <b-form-group :label="$t('regions.city')">
                  <multiple-select-input
                      :model.sync="item.city_id"
                      :values="cities"
                      :multiple="false"
                      label="name"
                      track-by="id"
                      @onSelect="onSelectCity($event, index)"
                  ></multiple-select-input>
                  <b-form-invalid-feedback
                      v-if="!validateState('city_id', index) && !$v.form.regions.$each[index].city_id.required"
                      :state="true">
                    {{ $t('regions.validations.city.required') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col lg="4" md="4" sm="12" xl="4">
                <b-form-group :label="$t('regions.county')">
                  <multiple-select-input
                      v-if="countiesProxy(index)"
                      :disabled="!item.city_id"
                      :model.sync="item.county_id"
                      :values="countiesProxy(index)"
                      :multiple="false"
                      label="name"
                      track-by="id"
                      @onSelect="onSelectCounty($event, index)"
                  ></multiple-select-input>
                </b-form-group>
              </b-col>

              <b-col lg="3" md="3" sm="12" xl="3">
                <b-form-group :label="$t('regions.district')">
                  <multiple-select-input
                      v-if="districtsProxy(index)"
                      :disabled="!item.county_id"
                      :model.sync="item.district_id"
                      :values="districtsProxy(index)"
                      :multiple="false"
                      label="name"
                      track-by="id"
                  ></multiple-select-input>
                </b-form-group>
              </b-col>
            </template>

            <b-col lg="6" md="6" sm="6" xl="6" class="float-left">
              <i class="bx bx-plus bx-add-button" @click="addNewRegion()"></i>
            </b-col>

            <b-col lg="6" md="6" sm="6" xl="6" class="float-right">
              <b-form-group :label="$t('regions.status')">
                <b-form-checkbox v-model="form.status" name="check-button" switch>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col
                class="float-right text-right"
                lg="12"
                md="12"
                sm="12"
                xl="12"
            >
              <b-button
                  class="mr-1"
                  variant="secondary"
                  @click="goBack"
              >
                <i class="fas fa-arrow-left"></i>
                {{ $t("general.cancel") }}
              </b-button>
              <b-button variant="primary" @click="createOrUpdate()">
                <i class="far fa-save"></i>
                {{ $t(id != null ? "general.save" : "general.create") }}
              </b-button>
            </b-col>
          </b-row>
        </template>
      </dashboard-box>
    </div>
  </div>
</template>
<script>
import DashboardBox from "@/assets/components/DashboardBox";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

import baseModule, {
  BASE_URL,
  CREATE_ITEM,
  ERROR,
  GET_ITEM,
  ITEM,
  LOADING,
  MODULE_NAME,
  SUCCESS,
  UPDATE_ITEM
} from "@/core/services/store/region.module";

import cityModule, {
  ITEMS_ALL as CITY_ITEMS,
  MODULE_NAME as CITY_MODULE_NAME,
  GET_ALL_ITEMS as GET_CITY_ITEMS
} from "@/core/services/store/city.module";

import countyModule, {
  ITEMS_ALL as COUNTY_ITEMS,
  MODULE_NAME as COUNTY_MODULE,
  GET_ALL_ITEMS as GET_COUNTY_ITEMS
} from "@/core/services/store/county.module";

import districtModule, {
  ITEMS_ALL as DISTRICT_ITEMS,
  MODULE_NAME as DISTRICT_MODULE,
  GET_ALL_ITEMS as GET_DISTRICT_ITEMS
} from "@/core/services/store/district.module";

import store from "@/core/services/store";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import MultipleSelectInput from "@/assets/components/inputs/MultipleSelectInput";
import _ from "lodash";

const _MODULE_NAME = MODULE_NAME;
const _CITY_MODULE_NAME = CITY_MODULE_NAME;
const _COUNTY_MODULE = COUNTY_MODULE;
const _DISTRICT_MODULE = DISTRICT_MODULE;

export default {
  name: "RegionsCreateEdit",
  mixins: [validationMixin],
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_NAME, baseModule);
    registerStoreModule(_CITY_MODULE_NAME, cityModule);
    registerStoreModule(_COUNTY_MODULE, countyModule);
    registerStoreModule(_DISTRICT_MODULE, districtModule);
  },
  components: {
    DashboardBox,
    MultipleSelectInput
  },
  validations: {
    form: {
      name: {
        required
      },
      description: {
        required
      },
      regions: {
        $each: {
          city_id: {
            required
          },
          district_id: {},
          county_id: {},
        }
      },
      status: {
        required
      }
    }
  },
  computed: {
    error() {
      return store.getters[_MODULE_NAME + "/" + ERROR];
    },
    loading() {
      return store.getters[_MODULE_NAME + "/" + LOADING];
    },
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
    item() {
     return store.getters[_MODULE_NAME + "/" + ITEM];
    },
    cities() {
      return store.getters[_CITY_MODULE_NAME + "/" + CITY_ITEMS] || [];
    },
    countiesProxy: {
      get()  {
        let self = this;
        return function (index) {
          return self.counties[index] || null;
        }
      },
      set() {
      }
    },
    districtsProxy: {
      get()  {
        let self = this;
        return function (index) {
          return self.districts[index] || null;
        }
      },
      set() {
      }
    }
  },
  data() {
    return {
      id: this.$route.params.id,
      counties: [],
      districts: [],
      form: {
        name: null,
        description: null,
        status: true,
        regions: []
      },
      defaultRegion: {
        city_id: null,
        county_id: null,
        district_id: null,
      }
    };
  },
  methods: {
    onSelectCity(selected, index) {
      this.counties[index] = [];
      this.districts[index] = [];

      this.form.regions[index].city_id = selected;
      this.form.regions[index].county_id = null;
      this.form.regions[index].district_id = null;
      this.getCounties(selected, index)
    },
    onSelectCounty(selected, index) {
      this.districts[index] = [];
      let city_id = this.form.regions[index].city_id;
      this.form.regions[index].district_id = null;
      this.getDistricts(city_id, selected, index)
    },
    addNewRegion() {
      let defaultRegion = JSON.parse(JSON.stringify(this.defaultRegion));
      this.form.regions.push(defaultRegion);
    },
    deleteRegion(index) {
      this.form.regions.splice(index, 1);
    },
    goBack() {
      this.$router.push({name: "management.regions"})
    },
    validateState(name, index) {
      if (!(_.isNull(index) || _.isUndefined(index))) {
        const {$dirty, $error} = this.$v.form.regions.$each[index][name]
        return $dirty ? !$error : null;
      } else {
        const {$dirty, $error} = this.$v.form[name];
        return $dirty ? !$error : null;
      }
    },
    getItem() {
      this.$store
          .dispatch(_MODULE_NAME + "/" + GET_ITEM, {
            url: BASE_URL + "/" + this.id,
          })
    },
    getCities() {
      this.$store
          .dispatch(_CITY_MODULE_NAME + "/" + GET_CITY_ITEMS, {})
    },
    getCounties(city_id, index) {
      let self = this;
      let filter = {
        city_id: city_id
      }
      this.$store
          .dispatch(_COUNTY_MODULE + "/" + GET_COUNTY_ITEMS, {
            filters: filter,
          }).then(response => {
         if (response.status) {
           self.counties = JSON.parse(JSON.stringify(self.counties));
           self.counties[index] = response.data;
         }
      })
    },
    getDistricts(city_id, county_id, index) {
      let self = this;
      let filter = {
        city_id: city_id,
        county_id: county_id
      }
      this.$store
          .dispatch(_DISTRICT_MODULE + "/" + GET_DISTRICT_ITEMS, {
            filters: filter
          }).then(response => {
        if (response.status) {
          self.districts = JSON.parse(JSON.stringify(self.districts));
          self.districts[index] = response.data;
        }
      })
    },
    createOrUpdate() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      let formData = _.clone(this.form);

      if (this.form.status) {
        formData.status = 1;
      } else {
        formData.status = 0;
      }

      if (this.id) {
        this.$store
            .dispatch(_MODULE_NAME + "/" + UPDATE_ITEM, {
              url: BASE_URL + "/" + this.id,
              contents: formData
            });
      } else {
        this.$store
            .dispatch(_MODULE_NAME + "/" + CREATE_ITEM, {
              url: BASE_URL,
              contents: formData,
            });
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: this.$t("general.dashboard"), route: "dashboard"},
      {title: this.$t(this.id ? "regions.edit_item" : "regions.create_item")}
    ]);

    if (this.cities && !this.cities.length) {
      this.getCities();
    }

    if (!this.counties && this.form.city_id) {
      this.getCounties();
    }

    if (!this.districts && this.form.city_id) {
      this.getDistricts();
    }

    if (this.id) {
      this.getItem();
    }
  },
  watch: {
    item(value) {
      if (value) {
        let item = value.item;
        if (item.status) {
          item.status = true;
        } else {
          item.status = false;
        }

        let regions = [];
        if (item.regions) {
          item.regions.forEach((subItem, index) => {
            let cityId = subItem.city_id;
            let distinctId = subItem.district_id;
            let countyId = subItem.county_id;

            if (subItem.city_id) {
              cityId = subItem.city.id;
              this.getCounties(cityId, index)
            }

            if (subItem.county_id) {
              countyId = subItem.county.id;

              this.getDistricts(cityId, countyId, index)
            }

            if (subItem.district_id) {
              distinctId = subItem.district_id
            }

            if (cityId || countyId || distinctId) {
              let region = {
                city_id: cityId,
                county_id: countyId,
                district_id: distinctId,
              }

              regions.push(region)
            }
          });
        }

        item.regions = regions;
        this.form = item;
      }
    },
    success(value) {
      let self = this;
      if (value) {
        setTimeout(() => {
          self.sweetAlertSuccess(self.$t("general.successfully_saved"),
              (response) => {
                if (response) {
                  self.$router.push({ name: "management.regions"});
                }
              });
          }, 500)
      }
    }
  }
};
</script>

<style scoped>
#dashboard-box {
  padding: 10px;
}

.bx-remove-button {
  background: #ff5b5c;
  border-radius: 50%;
  padding: 5px;
  color: #fff;
}

.bx-add-button {
  background: #5a8dee;
  border-radius: 50%;
  padding: 5px;
  color: #fff;
}
</style>
